import { getResponseErrorMessage } from '@/utils/error/getResponseErrorMessage'

export function throwResponseError (error, message) {
  const responseMessage = getResponseErrorMessage(error)
  throw new Error(responseMessage || message)
}
